module.exports = __webpack_public_path__ + "img/barva-zakladni_08_reflexni-cervena.6b480009.png";